import { Injectable } from '@angular/core'

import { Alert } from './alert.model'

@Injectable()
export class AlertService {
    alerts: Alert[]

    constructor() {
        this.alerts = []
    }

    alert(
        texto: string,
        titulo?: string,
        tipo?: 'warning' | 'danger' | 'success' | 'info',
        duracao?: number | boolean
    ) {
        const alert = new Alert(this, texto, titulo, tipo, duracao)

        this.alerts.push(alert)

        return alert
    }

    danger(texto: string, titulo?: string, duracao?: number | boolean) {
        return this.alert(texto, titulo, 'danger', duracao)
    }

    success(texto: string, titulo?: string, duracao?: number | boolean) {
        return this.alert(texto, titulo, 'success', duracao)
    }

    info(texto: string, titulo?: string, duracao?: number | boolean) {
        return this.alert(texto, titulo, 'info', duracao)
    }

    remover(alert: Alert) {
        const index = this.alerts.indexOf(alert)

        this.alerts.splice(index, 1)
    }
}



// WEBPACK FOOTER //
// ./src/app/common/alert/shared/alert.service.ts